const tagQueryKeys = {
  all: (searchQuery) => [
    "tags",
    searchQuery
  ],
  resources: (resourceIds) => [
    "tags-resources",
    resourceIds
  ],
  tag: (tagId) => [
    "tag",
    tagId
  ]
};

export { tagQueryKeys };
//# sourceMappingURL=tagsQueryKeys.js.map
